import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { INDRADatepickerModalComponent } from '@ibe.components/shared/datepicker-modal/datepicker-modal.indra.component';
import { ModalService, SidebarService } from '@ibe/services/ui';
import * as StopoverHotelsAction from '@ibe/store/actions/stopover-hotels.actions';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';


const moment = extendMoment(Moment);
const sinceDays = 366;

@Component({
	selector: 'app-partner-hotel-passengers',
	templateUrl: './partner-hotel-passengers.indra.component.html',
	styleUrls: ['./partner-hotel-passengers.component.scss']
})
export class INDRAPartnerHotelPassengersComponent implements OnInit, OnDestroy {

	isAlive = true;

	form = new FormGroup({
		checkin: new FormControl({}, [Validators.required]),
		checkout: new FormControl({}, [Validators.required]),
		passengers: new FormGroup({
			adults: new FormControl(1, [Validators.required]),
			children: new FormControl(0),
			rooms: new FormControl(1, [Validators.required])
		})
	});

	itemDropdown = [{
		type: 'adults',
		label: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.adults'),
		min: 1,
		max: 9,
		description: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.over15years'),
	},
	{
		type: 'children',
		label: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.children'),
		min: 0,
		max: 9,
		description: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.twoToElevenYears')
	}, {
		type: 'rooms',
		label: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.rooms'),
		min: 1,
		max: 2,
		description: this.INDRA_getTextTranslation('extrasSidebar.findHotels.label.room')
	}];

	partnerHotel$: Observable<any> = this.store.select(fromStore.getStopover);
	partnerHotel: any;
	INDRA_hasChanges: boolean = false;

	datepickerOptions: IMyDpOptions = {
		showClearDateBtn: false,
		disableUntil: { year: moment().year(), month: moment().month() + 1, day: parseFloat(moment().format('D')) },
		disableSince: { year: parseFloat(moment().add(sinceDays, 'days').format('YYYY')), month: parseFloat(moment().add(sinceDays, 'days').format('M')), day: parseFloat(moment().add(sinceDays, 'days').format('D')) },
		disableDateRanges: [],
		markCurrentDay: true,
		yearSelector: false,
		showSelectorArrow: false,
		openSelectorOnInputClick: true,
		allowSelectionOnlyInCurrentMonth: false,
		satHighlight: true,
		sunHighlight: true,
		showTodayBtn: false,
		ariaLabelInputField: this.INDRA_getTextTranslation('extrasSidebar.findHotels.aria.textInput'),
		dayLabels: { su: 'S', mo: 'M', tu: 'T', we: 'W', th: 'T', fr: 'F', sa: 'S' },
	};
	checkin: { date: { year: string; month: string; day: string; }; };
	checkout: { date: { year: string; month: string; day: string; }; };

	constructor(
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		private sidebarService: SidebarService,
		private dateSerivce: INDRADateService,
		private ibeAdminService: INDRAIbeAdminService
	) {
		this.datepickerOptions.dateFormat = this.dateSerivce.INDRA_getDateFormat().toLowerCase();

	}

	ngOnInit() {

		this.partnerHotel$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.partnerHotel = value;
					this.checkin = (value.checkin ? { date: { year: moment(value.checkin).format('YYYY'), month: moment(value.checkin).format('M'), day: moment(value.checkin).format('D') } } : null);
					this.form.get('checkin').setValue(this.checkin);
					this.checkout = (value.checkout ? { date: { year: moment(value.checkout).format('YYYY'), month: moment(value.checkout).format('M'), day: moment(value.checkout).format('D') } } : null);
					this.form.get('checkout').setValue(this.checkout);
					const adultCount = value.passengers.youngAdults ? value.passengers.adults + value.passengers.youngAdults : value.passengers.adults;
					const childrenCount = value.passengers.infants ? value.passengers.children + value.passengers.infants : value.passengers.children;
					this.form.get('passengers').get('adults').setValue(adultCount);
					this.form.get('passengers').get('children').setValue(childrenCount);
					this.form.get('passengers').get('rooms').setValue(value.passengers.rooms);
				}
			});

		this.form.valueChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.INDRA_hasChanges = true;
				}
			});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	get passengers() {
		return this.form.get('passengers');
	}


	INDRA_findHotels() {
		if (this.form.valid) {
			const checkin = moment(`${this.form.value.checkin.date.day}/${this.form.value.checkin.date.month}/${this.form.value.checkin.date.year}`, 'DD/MM/YYYY').toDate();
			const checkout = moment(`${this.form.value.checkout.date.day}/${this.form.value.checkout.date.month}/${this.form.value.checkout.date.year}`, 'DD/MM/YYYY').toDate();
			const dataStopoverHotel = Object.assign({}, this.partnerHotel, this.form.value, { checkin, checkout });
			this.store.dispatch(new StopoverHotelsAction.PutStopoverAction(dataStopoverHotel));
			this.sidebarService.previousSidebar();
		}
	}

	INDRA_checkValue(formcontrol) {
		const data = this.form.get(formcontrol).value;
		return data && data.date;
	}

	INDRA_getDatePickerOptions(field) {
		const newDatepickerOptions: IMyDpOptions = Object.assign({}, this.datepickerOptions);
		newDatepickerOptions.ariaLabelInputField = this.INDRA_getTextTranslation('extrasSidebar.findHotels.aria.select') + field + this.INDRA_getTextTranslation('extrasSidebar.findHotels.aria.date');
		return newDatepickerOptions;
	}

	INDRA_onDateChanged($event: IMyDateModel) {
	}

	INDRA_changeOpenDatepickerIndex($event) {
		// $event:
		// 1 = calendar opened
		// 2 = calendar closed by date select
		// 3 = calendar closed by calendar button
		// 4 = calendar closed by outside click (document click)
		// 5 = calendar closed by ESC key
		// 6 = calendar closed by API call

		// if ($event === 1) {
		// 	this.openCalendarIndex = index;
		// } else {
		// 	this.openCalendarIndex = null;
		// }
	}


	INDRA_openMobileDatepickerModal(index: 'checkin' | 'checkout') {

		let disableUntil = { year: moment().year(), month: moment().month() + 1, day: parseFloat(moment().format('D')) };
		const disableSince = { year: parseFloat(moment().add(sinceDays, 'days').format('YYYY')), month: parseFloat(moment().add(sinceDays, 'days').format('M')), day: parseFloat(moment().add(sinceDays, 'days').format('D')) };
		let valueDefMonth: Date = null;
		const checkInDate = this.form.get('checkin').value;
		const checkOutDate = this.form.get('checkout').value;

		const highlightDates = [];

		if (checkInDate && checkInDate.date) {
			valueDefMonth = moment(`${checkInDate.date.day}/${checkInDate.date.month}/${checkInDate.date.year}`, 'DD/MM/YYYY').toDate();
		}

		if (checkOutDate && checkOutDate.date) {
			valueDefMonth = moment(`${checkOutDate.date.day}/${checkOutDate.date.month}/${checkOutDate.date.year}`, 'DD/MM/YYYY').toDate();
		}

		if (index == 'checkout') {
			disableUntil = checkInDate.date;
			valueDefMonth = moment(`${disableUntil.day}/${disableUntil.month}/${disableUntil.year}`, 'DD/MM/YYYY').toDate();
			highlightDates.push(checkOutDate.date);
		}

		if (index == 'checkin') {
			highlightDates.push(checkInDate.date);
		}



		this.modalService.assignComponent(INDRADatepickerModalComponent, {
			params: {
				datepickerOptions: {
					highlightDates,
					disableUntil,
					disableSince
				},
				value: valueDefMonth
			},
			handleClose: (event) => {
				if (event.date) {
					this.form.get(index).setValue({ date: event.date });
				}
			}
		});
		this.modalService.open();
	}

	INDRA_adjustmentDate(date) {
		const newDate = date && date.date ? date.date : date;
		return newDate ? moment(`${newDate.year}-${newDate.month}-${newDate.day}`, 'YYYY-M-D').toDate() : null;
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}



}
